<template>
  <div :id="loadingPage" class="vs-con-loading__container">
    <departament-modal
      v-model="displayModal"
      :item="item"
      @refresh="getData"
    ></departament-modal>
    <vs-card class="mb-4">
      <vs-row>
        <vs-col vs-justify="center" vs-align="center" vs-w="12">
          <departament-table
            :data="data"
            @add="addItem"
            @edit="editItem"
            @delete="deleteItem"
            @loadMore="loadMore"
            @search="search"
          />
        </vs-col>
      </vs-row>
    </vs-card>
  </div>
</template>

<script>
import DepartamentTable from './components/DepartamentTable.vue'
import DepartamentModal from './components/DepartamentModal.vue'
import request from './request.js'
import loading from '@/mixins/Loading'


export default {
  components: {
    DepartamentTable,
    DepartamentModal,
  },
  computed: {},
  data() {
    return {
      data: [],
      item: { id: '', name: '' },
      displayModal: false,
      frequencies: [],
      lastPage: '1',
      loading: false,
      loadingPage: 'budget-departament-loading',
      params: {
        search: '',
        page: 1,
      },
    }
  },
  methods: {
    addItem() {
      this.item = { id: '', name: '' }
      this.displayModal = true
    },
    editItem(item) {
      this.item = { id: item.id, name: item.name }
      this.displayModal = true
    },
    getData() {
      //   this.openLoading(this.loadingPage)
      const payload = {
        name: this.params.search.trim(),
        page: this.params.page,
      }
      request
        .list(payload)
        .then((response) => {
          this.data = [...response.data.data]
          this.lastPage = response.data.last_page
          this.closeLoading(this.loadingPage)
        })
        .catch((response) => {
          //this.showValidationErrors(response)
          this.closeLoading(this.loadingPage)
        })
    },
    deleteItem(item) {
       const payload = {
        id: item.id,
      }
      request
        .delete(payload)
        .then((response) => {
          this.closeLoading(this.loadingPage)
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Departement Deleted.',
          })
          this.getData()
        })
        .catch((response) => {
          this.closeLoading(this.loadingPage)
            this.$vs.notify({
            color: 'danger',
            title: 'Error',
            text: 'The given data was invalid.',
          })
          this.showValidationErrors(response)
        })
    },
    loadMore() {
      return
      if (this.params.page >= this.lastPage) {
        return
      }
      this.params.page++
      this.getData()
    },
    search: function (text = '') {
      this.params.search = text
      this.params.page = 1
      this.getData()
    },
  },
  mixins: [loading],
  mounted() {
    this.getData()
  },
}
</script>

<style>
</style>